// extracted by mini-css-extract-plugin
module.exports = {"container":"tail_container__1b2tH","tailText":"tail_tailText__1E_YM","tailAText":"tail_tailAText__HZngW"};